import * as types from '../mutation-types'
import axios from '@/utils/axios'
import swal from 'vue-sweetalert2'

const state = {
  marketplaceOrders: [],
  marketplaceOrderIds: [],
  marketplaceOrderDetail: null,
  scanResult: null,
  marketplaceOrdersMeta: {},
  currentPage: 1
}

const getters = {
  marketplaceOrders: state => state.marketplaceOrders,
  marketplaceOrderIds: state => state.marketplaceOrderIds,
  marketplaceOrderDetail: state => state.marketplaceOrderDetail,
  scanResult: state => state.scanResult,
  marketplaceOrdersMeta: state => state.marketplaceOrdersMeta,
  currentPage: state => state.currentPage
}

// actions
const actions = {
  async fetchMarketplaceOrders ({commit, state}, params) {
    await axios.get('/marketplace/order', params)
      .then(response => {
        let orderIds = []
        response.data.forEach(function (order) {
          orderIds.push(order.id)
        })
        commit(types.FETCH_MARKETPLACE_ORDER_LIST, response)
        commit(types.SET_MARKETPLACE_ORDER_IDS, orderIds)
      }).catch(error => {
        console.log(error)
        swal({
          title: 'Error 500, Internal Server Error',
          icon: 'error'
        })
      })
  },
  updateCurrentPageNum ({commit, state}, pageNum) {
    commit(types.SET_CURRENT_PAGE_NUM, pageNum)
  },
  async scanMarketplaceOrderTrackingNo ({commit, state}, params) {
    await axios.post('/marketplace/order/scan-tracking-no', params)
      .then(response => {
        let orderIds = []
        response.data.forEach(function (order) {
          orderIds.push(order.id)
        })
        commit(types.FETCH_MARKETPLACE_ORDER_LIST, response)
        commit(types.SET_MARKETPLACE_ORDER_IDS, orderIds)
      }).catch(error => {
        console.log(error)
        swal({
          title: 'Error 500, Internal Server Error',
          icon: 'error'
        })
      })
  },
  async fetchMarketplaceOrderDetail ({commit}, orderId) {
    commit('SET_MARKETPLACE_ORDER_DETAIL', {})
    if (orderId) {
      await axios.get('/marketplace/order/' + orderId)
      .then(response => {
        commit(types.SET_MARKETPLACE_ORDER_DETAIL, response.data)
      }).catch(error => {
        console.log(error)
        swal({
          title: 'Error 500, Internal Server Error',
          icon: 'error'
        })
      })
    }
  }
}

// mutations
const mutations = {
  [types.FETCH_MARKETPLACE_ORDER_LIST] (state, response) {
    state.marketplaceOrders = response.data
    state.marketplaceOrdersMeta = response.meta
  },
  [types.SET_MARKETPLACE_ORDER_IDS] (state, orderIds) {
    state.marketplaceOrderIds = orderIds
  },
  [types.SET_MARKETPLACE_ORDER_DETAIL] (state, detail) {
    state.marketplaceOrderDetail = detail
  },
  [types.SCAN_MARKETPLACE_ORDER_TRACKING_NO] (state, result) {
    state.scanResult = result
  },
  [types.SET_CURRENT_PAGE_NUM] (state, pageNum) {
    state.currentPage = pageNum
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
